import React from "react";
import "./PageSkeleton.css";

/**
 * Route-level loading placeholder, shown while a lazy page chunk downloads.
 *
 * Replaces a bare centred spinner. The spinner communicated only "wait" and
 * occupied a single point, so the page snapped into place when the chunk
 * arrived. This blocks out the shape nearly every /app and /admin page shares —
 * title, action button, stat tiles, filter bar, list — so the eye is already
 * where the content will be and the arrival reads as a fill.
 *
 * Presentation only: renders empty divs, holds no state, starts no timers,
 * fetches nothing. Swapping it in for the spinner cannot change behaviour.
 */
const B = ({ className }) => <span className={`pskel__b ${className}`} />;

/**
 * `variant="plain"` — a neutral placeholder with no implied layout.
 *
 * The dashboard shape below is right for /app and /admin, but the outer Suspense
 * boundary in App.js also covers the public marketing site, where the real page
 * is a hero and prose — showing stat tiles and table rows there promises a
 * layout that never arrives, which is worse than showing nothing specific.
 */
const PageSkeleton = ({ tiles = 4, rows = 5, variant = "page" }) => {
  if (variant === "plain") {
    return (
      <div className="pskel pskel--plain" role="status" aria-label="Loading">
        <B className="pskel__plain-a" />
        <B className="pskel__plain-b" />
        <B className="pskel__plain-c" />
      </div>
    );
  }

  return (
  <div className="pskel" role="status" aria-label="Loading page">
    <div className="pskel__head">
      <div className="pskel__head-tx">
        <B className="pskel__title" />
        <B className="pskel__sub" />
      </div>
      <B className="pskel__btn" />
    </div>

    <div className="pskel__tiles">
      {Array.from({ length: tiles }, (_, i) => <B key={i} className="pskel__tile" />)}
    </div>

    <B className="pskel__bar" />

    <div className="pskel__panel">
      {Array.from({ length: rows }, (_, i) => (
        <div className="pskel__row" key={i}>
          <B className="pskel__av" />
          <span className="pskel__lines">
            <B className="pskel__l1" />
            <B className="pskel__l2" />
          </span>
          <B className="pskel__end" />
        </div>
      ))}
    </div>
  </div>
  );
};

export default PageSkeleton;
